import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ChartsModule } from 'ng2-charts';
import { ReportComponent } from './report/report.component';
import { ReportRoutingModule } from './report-routing.module';
import { ReportDoughnutComponent } from './report-doughnut/report-doughnut.component';
import { ReportPieComponent } from './report-pie/report-pie.component';
import { DxChartModule } from 'devextreme-angular';
import { DxPieChartModule } from 'devextreme-angular';
//import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';
import { ReportService } from './report.service';
import { ReportBarComponent } from './report-bar/report-bar.component';
import { ReportDoughnutAverageComponent } from './report-doughnut-average/report-doughnut-average.component';
import { SharedModule } from '../../shared/shared.module';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoomService } from '../../dashboard/chat/room/room.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    ChartsModule,
    DxChartModule,
    DxPieChartModule,
    AngularMultiSelectModule,
    ReportRoutingModule,
    NgxSpinnerModule
  ],
  declarations: [
    ReportComponent,
    ReportDoughnutComponent,
    ReportPieComponent,
    ReportBarComponent,
    ReportDoughnutAverageComponent
  ],
  providers: [
    RoomService,
    ReportService,
    NgxSpinnerService
  ],
  /*exports: [
    ReportComponent
  ]*/
})
export class ReportModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/report/report.module.ts